<template>
  <button
    type="button"
    class="seth-btn"
    :class="[`v-${variant}`, { pill, block }]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    variant: { type: String, default: 'primary' }, // primary | secondary | accent | eco
    pill: { type: Boolean, default: false },
    block: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.seth-btn {
  display: inline-flex;
  width: auto;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 0.9375rem;
  letter-spacing: 0.02em;
  padding: 12px 24px;
  min-height: 46px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition-base);
  white-space: nowrap;
}
.seth-btn.pill { border-radius: var(--radius-pill); }
.seth-btn.block { display: flex; width: 100%; }

.v-primary {
  background: var(--color-primary);
  color: var(--color-on-primary);
  border: 1px solid var(--color-primary);
}
.v-primary:hover { background: var(--color-primary-hover); }

.v-secondary {
  background: transparent;
  color: var(--seth-navy);
  border: 1px solid var(--seth-navy);
}
.v-secondary:hover { background: var(--seth-navy); color: #fff; }

.v-accent {
  background: var(--color-accent);
  color: var(--color-on-accent);
  border: 1px solid var(--color-accent);
}
.v-accent:hover { background: var(--color-accent-hover); }

.v-eco {
  background: var(--seth-green);
  color: #fff;
  border: 1px solid var(--seth-green);
}
.v-eco:hover { background: var(--seth-green-700); }
</style>
